import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
import store from './store/store';
import { Provider } from 'react-redux';
// import * as serviceWorker from './serviceWorker';

import { BrowserRouter, Route, Switch, Redirect, Link } from "react-router-dom";
// import {PrivateRoute} from './PrivateRoute';
// import {PrivateRouteInternal} from './PrivateRouteInternal';

// import AuthLayout from "./layouts/AuthLayout.jsx";
// import RegisterLayout from "./layouts/RegisterLayout.jsx";
// import ForgotPassword from "./layouts/ForgotPassword.jsx";
// import ResetPassword from "./layouts/ResetPassword.jsx";
// import MainLayout from "./layouts/MainLayout.jsx";

// import AuthInternalLayout from "./layouts/internal/AuthInternalLayout.jsx";
import MenuPageLayout from "./pages/MainPageLayout";// "./layouts/internal/MainInternalLayout.jsx";
// import MenuPageLayout from "../"
import { 
  Result,
  Button
} from 'antd';

// import { initializeFirebase } from './push-notification';

ReactDOM.render(
  <Provider store={store}>
  	<BrowserRouter basename={'/pusatdata'}>
    	<Switch>
    		<Route path="/" exact component={MenuPageLayout} />
      
        <Route path="" render={
            () => 
                <Result
                    status="404"
                    title={
                      <div>
                      404
                      </div>
                    }
                    subTitle={
                      <div>
                        <h1>Maaf, halaman tidak ditemukan</h1><br />
                        <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} height="50" /><br /><br />
                        <Link to="/">
                          <Button type="primary">
                            kembali ke halaman utama
                          </Button>
                        </Link>
                      </div>
                    }
                />
        } />
    	</Switch>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// initializeFirebase();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
